var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataEle)?_c('div',{attrs:{"id":"components-back-top-demo-custom"}},[_c('a-back-top',{attrs:{"target":_vm.sss}},[_c('img',{attrs:{"src":require("./gotop.svg"),"alt":""}}),_c('div',{staticClass:"ant-back-top-inner"},[_c('a-icon',{attrs:{"type":"vertical-right"}}),_vm._v(" 回到顶部 ")],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }